import { defineMessages } from 'react-intl'

const messages = defineMessages({
  youWonCredit: {
    id: 'staywallet.you-won-credit',
  },
  earnStaywallet: {
    id: 'staywallet.earn-list',
  },
  staywalletTooltip: {
    id: 'staywallet.earn-list-tooltip',
  },
})

export default messages
